module.exports = __webpack_public_path__ + "static/media/icon-deposit-with-border.875719fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-deposit-with-border.svg
// module id = 1230
// module chunks = 19